module.exports = __webpack_public_path__ + "img/UnifiedSalesReport.8a143ed0.jpg";